module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAYCAYAAADtaU2/AAAAAXNSR0IArs4c6QAAARVJREFUSA291MsRgjAQBuBdjh4cSsES6MCzJ+zABjzZgB3oybMdUIKWwnjwiv5kAiOEPBd3hglkkv1mkxCmP8TxsbswUfFq3uW5vDcgs6VdhXJFxMU6X9XaWxQeUM1xgT58fVdgmZiig9NSe12kYhuqefGKXSiqPW1ue1HYF0XVYnAIKgaHooB/Dteh3uboDIkYFPl7GCh+cCTyhWNR5O/2WKO4XdCpTx7e5yIFRU4eoxqy4akojEzdn6pSjaJl4sq07BIo8mct0RMvphjjUiisbo99EqrBXKE1hW1rTOP7C8SFmybrvlAU83oYHzF4DDqBQ/FY1Aj74inoLOzCU1ErPIdLoE54jEuhyOsVOO14vAZ7DvoA9vW68BS8vRMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/AB_checkmark_boostabostad.png
// module id = 137
// module chunks = 0